/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/no-unescaped-entities */
'use client';

import React from 'react';
import { Link } from '@/navigation';
import View from '@/components/view';
import { Content } from '@/typings/projects';
import Detailed from '@/components/details/card';
import ImageGallery from '@/components/gallery';
import VideoBanner from '@/components/banner/video';
import MarkDownParser from '@/components/markdown/content';

type Props = {
  data: Content | null;
  recents: Content[] | null;
};

const ProjectDetailsClient: React.FC<Props> = ({ data, recents }) => {
  return (
    <React.Fragment>
      {data?.video && (
        <VideoBanner heading={data?.title} source={data?.video} />
      )}
      <View className="section flex flex-col gap-2">
        <View className="grid grid-cols-1 sm:grid-cols-[1fr_2fr] gap-12 mt-8">
          <View className="hidden sm:flex flex-col gap-4">
            <Detailed.Aside heading="Recent Projects">
              <View className="flex flex-col gap-4 p-4">
                {recents &&
                  recents?.length > 0 &&
                  recents?.map((item, index) => {
                    return (
                      <Link
                        href={{
                          pathname: `/projects/[slug]`,
                          params: {
                            slug: item.slug as any,
                          },
                        }}
                        key={index}
                        className="cursor-pointer hover:bg-[var(--app-color-green)] hover:text-white rounded-xl shadow-md transition-all bg-default-50 bg-opacity-50"
                      >
                        <View className="flex gap-4 items-center p-4">
                          <img
                            alt="image"
                            width={48}
                            height={48}
                            src={String(item.image)}
                            className="rounded-lg h-12 w-12"
                          />
                          <p className="line-clamp-2">{item.title}</p>
                        </View>
                      </Link>
                    );
                  })}
              </View>
            </Detailed.Aside>
          </View>
          <View className="flex flex-col gap-2">
            {data?.content && <MarkDownParser content={data?.content} />}
          </View>
        </View>
        {data?.gallery && data?.gallery?.length > 0 && (
          <ImageGallery items={data?.gallery} />
        )}
      </View>
    </React.Fragment>
  );
};
export default ProjectDetailsClient;
